export default "__VITE_ASSET__8fd49ce0__"